import {setAuthToken as setSystemOfRecordToken} from './SystemOfRecordService';

// any API that follow the pattern established in SystemOfRecordService can have its AUTH token set here
const setUserAuthToken = (token?: string): void => {
  setSystemOfRecordToken({token});
};

export default setUserAuthToken;
